import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import molassesService from "../services/molassesService";

// Create
const defaultState = {
  loading: false,
  data: null,
  error: null,
};

export const create = createAsyncThunk("molasses/create", async (data) => {
  return await molassesService.create(data);
});

const molassesCreateReducer = createSlice({
  name: "createMolasses",
  initialState: defaultState,
  extraReducers: (builder) => {
    builder.addCase(create.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(create.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.error = "";
    });
    builder.addCase(create.rejected, (state, action) => {
      state.loading = false;
      state.data = null;
      state.error = action.error.message;
    });
  },
});

export const MolassesCreateReducer = molassesCreateReducer.reducer;

// List
const defaultMolassesListState = {
  loading: false,
  data: null,
  error: null,
};

export const molassesList = createAsyncThunk("molasses/list", async (data) => {
  return await molassesService.getList(data);
});

const molassesListReducer = createSlice({
  name: "molassesList",
  initialState: defaultMolassesListState,
  extraReducers: (builder) => {
    builder.addCase(molassesList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(molassesList.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.error = "";
    });
    builder.addCase(molassesList.rejected, (state, action) => {
      state.loading = false;
      state.data = null;
      state.error = action.error.message;
    });
  },
});

export const MolassesListReducer = molassesListReducer.reducer;

// Get
const defaultMolassesGetState = {
  loading: false,
  data: null,
  error: null,
};

export const getMolasses = createAsyncThunk("molasses/get", async (id) => {
  return await molassesService.getMolasses(id);
});

const molassesGetReducer = createSlice({
  name: "molassesGet",
  initialState: defaultMolassesGetState,
  reducers: {
    resetGetMolasses: (state) => {
      state.loading = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getMolasses.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getMolasses.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.error = "";
    });
    builder.addCase(getMolasses.rejected, (state, action) => {
      state.loading = false;
      state.data = null;
      state.error = action.error.message;
    });
  },
});

export const { resetGetMolasses } = molassesGetReducer.actions;
export const MolassesGetReducer = molassesGetReducer.reducer;

// Update
const defaultMolassesUpdateState = {
  loading: false,
  data: null,
  error: null,
};

export const updateMolasses = createAsyncThunk(
  "molasses/update",
  async (data) => {
    return await molassesService.updateMolasses(data);
  }
);

const molassesUpdateReducer = createSlice({
  name: "molassesUpdate",
  initialState: defaultMolassesUpdateState,
  extraReducers: (builder) => {
    builder.addCase(updateMolasses.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateMolasses.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.error = "";
    });
    builder.addCase(updateMolasses.rejected, (state, action) => {
      state.loading = false;
      state.data = null;
      state.error = action.error.message;
    });
  },
});

export const MolassesUpdateReducer = molassesUpdateReducer.reducer;

// Get Fermentation dropdown
const defaultListFermentation = {
  loading: false,
  data: null,
  error: null,
};

export const getFermentationOptions = createAsyncThunk(
  "molasses/get-fermentation-option",
  async () => {
    return await molassesService.getFermentationOptions();
  }
);

const fermentationOptions = createSlice({
  name: "molassesFermentationOptions",
  initialState: defaultListFermentation,
  extraReducers: (builder) => {
    builder.addCase(getFermentationOptions.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getFermentationOptions.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.error = "";
    });
    builder.addCase(getFermentationOptions.rejected, (state, action) => {
      state.loading = false;
      state.data = null;
      state.error = action.error.message;
    });
  },
});

export const FermentationOptions = fermentationOptions.reducer;

// Sent to Fermentation
const defaultSendToFermentation = {
  loading: false,
  data: null,
  error: null,
};

export const sendMolassesToFermentation = createAsyncThunk(
  "molasses/update",
  async (data) => {
    return await molassesService.sendToFermentation(data);
  }
);

const sendToFermentationReducer = createSlice({
  name: "sendToFermentation",
  initialState: defaultSendToFermentation,
  extraReducers: (builder) => {
    builder.addCase(sendMolassesToFermentation.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(sendMolassesToFermentation.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.error = "";
    });
    builder.addCase(sendMolassesToFermentation.rejected, (state, action) => {
      state.loading = false;
      state.data = null;
      state.error = action.error.message;
    });
  },
});

export const SendToFermentationReducer = sendToFermentationReducer.reducer;
